import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  LabeledInput,
  Spinner,
  TxtTitle,
} from 'components';
import { passwordField } from 'config/fieldsProps';
import { observer } from 'mobx-react-lite';
import { useAuthState } from 'state';
import { useFormInputState } from 'hooks';
import { useState } from 'react';
import styles from './VerifyPassword.module.scss';

/**
 * VerifyPassword
 *
 * @return {JSX.Element}
 */
const VerifyPassword = ({ className, isLoading, onSuccess, onError }) => {
  const [isLoadingCheck, setIsLoadingCheck] = useState(false);
  const [error, setError] = useState('');
  const authState = useAuthState();
  const [state, handleInput] = useFormInputState(() => ({ password: '' }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingCheck(true);
    try {
      await authState.verifyUserPassword(state.password);
      if (onSuccess) {
        onSuccess();
      } else {
        setIsLoadingCheck(false);
      }
    } catch (e) {
      setError(e.message);
      setIsLoadingCheck(false);
      if (onError) {
        onError(e);
      }
    }
  };

  const isLoadingLocal = isLoadingCheck || isLoading;

  return (
    <FlexContainer
      className={classNames(
        styles.VerifyPassword,
        className,
        VerifyPassword.displayName
      )}
      column
      gap
      flex
    >
      <FlexContainer>
        <TxtTitle x>Please enter your password</TxtTitle>
      </FlexContainer>
      <form onSubmit={handleSubmit}>
        <FlexContainer column>
          <FlexContainer column>
            <LabeledInput
              label="Password"
              reverse
              onChange={handleInput}
              value={state.password}
              disabled={isLoadingLocal}
              error={error}
              autoFocus
              {...passwordField}
            />
          </FlexContainer>
          <FlexContainer column>
            <Button type="submit" warn>
              {isLoadingLocal ? <Spinner /> : 'Confirm'}
            </Button>
          </FlexContainer>
        </FlexContainer>
      </form>
    </FlexContainer>
  );
};

VerifyPassword.displayName = 'VerifyPassword';

export default observer(VerifyPassword);
